import { render, staticRenderFns } from "./SummaryMenu.vue?vue&type=template&id=5f65fd3f&scoped=true"
import script from "./SummaryMenu.vue?vue&type=script&lang=ts"
export * from "./SummaryMenu.vue?vue&type=script&lang=ts"
import style0 from "./SummaryMenu.vue?vue&type=style&index=0&id=5f65fd3f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f65fd3f",
  null
  
)

export default component.exports